module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "good-item"
  }, [_c('div', {}, [_c('div', {
    staticClass: "good-img"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.goodsDetails(_vm.msg.productId)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl,
      "alt": _vm.msg.productName
    }
  })])]), _vm._v(" "), _c('h6', {
    staticClass: "good-title",
    domProps: {
      "innerHTML": _vm._s(_vm.msg.itemTitle)
    }
  }, [_vm._v(_vm._s(_vm.msg.itemTitle))]), _vm._v(" "), _c('h3', {
    staticClass: "sub-title ellipsis"
  }, [_vm._v(_vm._s(_vm.msg.subTitle))]), _vm._v(" "), _c('div', {
    staticClass: "good-price pr"
  }, [_c('div', {
    staticClass: "ds pa"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.goodsDetails(_vm.msg.productId)
      }
    }
  }, [_c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": "查看详情"
    }
  })], 1), _vm._v(" "), _c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": "立即购买",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": _vm.goodsDetails
    }
  })], 1), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("￥")]), _vm._v(_vm._s(Number(_vm.msg.price).toFixed(2)))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5508cabc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mallGoods.vue
// module id = 657
// module chunks = 0